import { create } from 'zustand';

// Единое состояние оболочки (AppShell). Заменяет рассинхронизированную
// `window CustomEvent('sidebar-toggle')`-шину, которой раньше синхронизировались
// все layout'ы. Подписка на стор делает синхронизацию автоматически.
const SIDEBAR_KEY = 'pf2e-sidebar-collapsed';

const readBool = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

const writeBool = (key: string, value: boolean): void => {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    /* localStorage недоступен (private mode) — состояние живёт только в памяти */
  }
};

interface UiState {
  /** Десктоп: свёрнут ли сайдбар в icon-rail. Персистится. */
  sidebarCollapsed: boolean;
  /** Мобайл: открыт ли overlay-drawer. Не персистится. */
  mobileDrawerOpen: boolean;

  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  openMobileDrawer: () => void;
  closeMobileDrawer: () => void;
  toggleMobileDrawer: () => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  sidebarCollapsed: readBool(SIDEBAR_KEY),
  mobileDrawerOpen: false,

  toggleSidebar: () => {
    const next = !get().sidebarCollapsed;
    writeBool(SIDEBAR_KEY, next);
    set({ sidebarCollapsed: next });
  },

  setSidebarCollapsed: (collapsed) => {
    writeBool(SIDEBAR_KEY, collapsed);
    set({ sidebarCollapsed: collapsed });
  },

  openMobileDrawer: () => set({ mobileDrawerOpen: true }),
  closeMobileDrawer: () => set({ mobileDrawerOpen: false }),
  toggleMobileDrawer: () => set({ mobileDrawerOpen: !get().mobileDrawerOpen }),
}));
